import { registerStore, select, dispatch } from '@wordpress/data'

import reducer from './reducer'
import * as actions from './actions'
import * as controls from './controls'
import * as selectors from './selectors'
import * as resolvers from './resolvers'

const initialState = {}
const STORE_NAME = '@photomart/order-journey'

const store = registerStore(STORE_NAME, {
  reducer, selectors, actions, resolvers, controls, initialState
})

const selector = select(STORE_NAME)
const dispatcher = dispatch(STORE_NAME)

export {
  STORE_NAME,
  store,
  selector,
  dispatcher
}
